<template>
  <b-icon icon="box-arrow-in-left" />
</template>

<script>
export default { name: "UnarchiveIcon", }
</script>
